/**
 * @file Component to display an instruction how to use a specific component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationsService } from '../../configurations.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * Component to display an instruction how to use a specific component.
 */
var InstructionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InstructionComponent, _super);
    /**
     * Constructs a InstructionComponent
     */
    function InstructionComponent(http, configurationsService, translateService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.configurationsService = configurationsService;
        _this.translateService = translateService;
        /**
         * Gets sets the specific name of the instruction.
         * The subject name is used to get the right instruction to retrieve.
         */
        // tslint:disable-next-line:no-input-rename
        _this.subject = undefined;
        /**
         * Indicates the progress of the instruction loading.
         * Possible values: 'loading', 'available', 'error'
         */
        _this.mode = 'loading';
        /** The content of the loaded instruction */
        _this.text = undefined;
        /** Boolean flag to indicate whether the instruction is shown or collapsed. */
        _this.open = false;
        return _this;
    }
    /**
     * Gets the content of the retrieved instruction.
     * @returns HTML content representing the instruction.
     */
    InstructionComponent.prototype.getText = function () {
        return this.text;
    };
    /**
     * Alternates between an open and collapsed state of the instruction.
     */
    InstructionComponent.prototype.toggle = function (event) {
        // Stop event propagation
        event.stopPropagation();
        this.open = !this.open;
        // First time open? Load the instruction
        if (!this.text && this.open) {
            var self_1 = this;
            this.instructionPath = this.subject + '.' + this.translateService.currentLang + '.html';
            this.subscriptionPool.add(this.http.get(this.instructionPath, { responseType: 'text' }).subscribe(function (result) {
                // #1919: in productie wordt index.html teruggegeven als de instructie niet is gevonden.
                if (result.slice(0, 15) === '<!DOCTYPE html>') {
                    self_1.mode = 'error';
                }
                else {
                    self_1.text = result;
                    self_1.mode = 'available';
                }
            }, function (reason) {
                self_1.mode = 'error';
            }));
        }
    };
    /**
     * Closes the instruction.
     */
    InstructionComponent.prototype.close = function () {
        this.open = false;
    };
    /**
     * Checks whether the instruction is in a specific loading mode.
     * @param mode The loading mode to check ('loading', 'available', 'error')
     * @returns True when the component is in the given mode, otherwise false.
     * @see InstructionComponent.mode
     */
    InstructionComponent.prototype.inMode = function (mode) {
        return (this.mode === mode);
    };
    /**
     * Checks whether the instruction is open or collapsed.
     * @returns True when the instruction is open and shown.
     */
    InstructionComponent.prototype.isOpen = function () {
        return this.open;
    };
    return InstructionComponent;
}(AbstractBase));
export { InstructionComponent };
